module.exports = __webpack_public_path__ + "img/原位芯片.085d41b2.png";